import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import { Switch, Route } from "react-router-dom";
import Login from "./Pages/Login.js";
import "firebase/auth";
import "firebase/firestore";

import firebase from "firebase/app";

firebase.initializeApp( {
  apiKey: "AIzaSyCK6umTU-1Uar6EMNVXMzh7GmTBz6ceP5o",
  authDomain: "statsmarathonbaiedeschaleurs.firebaseapp.com",
  projectId: "statsmarathonbaiedeschaleurs",
  storageBucket: "statsmarathonbaiedeschaleurs.appspot.com",
  messagingSenderId: "10259120384",
  appId: "1:10259120384:web:adef62e0bd5f8c94cdb3e5"
});

console.log(firebase.auth().currentUser)

ReactDOM.render(
  <HashRouter>
      <Switch>
        <Route exact path="/" component = {App}/>
        <Route exact path="/login" component = {Login}/>
      </Switch>
  </HashRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
